import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

export const taskCompletionDialogStyleId = 'blocks-task-completion-dialog-theme';

export const taskCompletionDialogBridgeStyles = {
  'task-completion-dialog': {
    '--local-task-dialog-bg': tokens.color.background.primary,
    '--local-task-dialog-pad': tokens.spacing.xl,
    '--local-task-dialog-gap': tokens.spacing.lg,
    '--local-task-dialog-font': tokens.font.family.body,
  },
};
